// extracted by mini-css-extract-plugin
export default {"header":"cp4po7f2b","stars":"cnyt6bfpn","buttonContainer":"ccn1tyye9"};